
import { ITeamPhone } from "../types/teamPhone";
import axios from "./config.service";

export function getTeamWithPhoneByTeamId(id: number) {
  return axios.get(`/teamPhone/team/${id}`).then((r) => r.data) as Promise<ITeamPhone>;
}
